import {cssTheme} from '@yandex-delivery/blocks/theme'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

import {PIN_HEIGHT, PIN_SIZE} from '../consts'

const STICK_WIDTH = 3
const STICK_HEIGHT = 24

const SHADOW_WIDTH = 12
const SHADOW_HEIGHT = 6

const LEVITATING_HEIGHT = 10

export const container = css`
  position: absolute;
  top: -${PIN_HEIGHT}px;
  transform: translateX(-50%);
  transition: transform 0.2s cubic-bezier(0.455 0.03 0.515 0.955);
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const containerDraggable = css`
  cursor: grab;
`
export const dragging = css`
  transform: translate(-50% -${LEVITATING_HEIGHT}px);
`
export const paper = css`
  block-size: ${PIN_SIZE}px;
  background-color: ${cssTheme.default.day.background};
  border-radius: ${spacing(2)};
  padding: ${spacing(0.5)};
`
export const arrow = css`
  block-size: ${spacing(1)};
`
export const arrowPoint = css`
  position: relative;
  margin-block-start: ${spacing(0.25)};
  inline-size: 14px;
  block-size: 14px;
  background-color: ${cssTheme.colors.warmGray[450]};
  border-radius: 100%;

  &::after {
    content: '';
    position: absolute;
    inset-block-start: 3px;
    inset-inline-start: 3px;
    inline-size: 8px;
    block-size: 8px;
    background-color: ${cssTheme.default.day.background};
    border-radius: 100%;
  }
`
export const stick = css`
  position: relative;
  inline-size: ${STICK_WIDTH}px;
  block-size: ${STICK_HEIGHT}px;
  background-color: ${cssTheme.default.day.text};
  border-radius: ${spacing(0, 0, 1, 1)};

  &::after {
    content: '';
    position: absolute;
    inline-size: ${SHADOW_WIDTH}px;
    block-size: ${SHADOW_HEIGHT}px;
    border-radius: 100%;
    background: rgba(0 0 0 0.2);
    filter: blur(1px);
    inset-inline-start: -${SHADOW_WIDTH / 2 - STICK_WIDTH / 2}px;
    inset-block-start: calc(100% - ${SHADOW_HEIGHT / 2}px);
    transition: all 0.2s cubic-bezier(0.455 0.03 0.515 0.955);
  }
`
export const stickDragging = css`
  &::after {
    filter: blur(4px);
    inset-block-start: calc(100% - ${SHADOW_HEIGHT / 2 - LEVITATING_HEIGHT}px);
  }
`
export const placeMarkWrap = css`
  inline-size: 40px;
  block-size: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${cssTheme.colors.deliveryGrey[125]};
  border-radius: ${spacing(1.5)};
`
export const placeMarkWrap_destination = css``
export const placeMarkWrap_numeric = css``
export const placeMarkWrap_source = css`
  background-color: ${cssTheme.colors.deliveryGrey[450]};
`
